import * as S from '@/pages/reservation/payment/styles';
import {
  ALERT_MESSAGE_TYPE,
  getPreReservation,
  getSureUserId,
  PAGE_NAME,
  removeSureUserId,
  SESSION_STORAGE_KEY,
  useConfirmPreReservationPayment,
  useDetectMobile,
} from '@orcar/common-d2c';
import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getReservationAttribution } from '@/utils/analytics';

const RequestPaymentPage = () => {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const paymentKey = searchParams.get('paymentKey');
  const amount = Number(searchParams.get('amount'));
  const orderId = searchParams.get('orderId');

  const hasRequestedPayment = useRef(false);

  const { isMobile, screenHeight } = useDetectMobile();

  const confirmPayment = useConfirmPreReservationPayment();

  useEffect(() => {
    const sureUserId = getSureUserId();
    const preReservationId = sessionStorage.getItem(
      SESSION_STORAGE_KEY.PRE_RESERVATION_ID,
    );
    const isFullCoverage =
      sessionStorage.getItem(SESSION_STORAGE_KEY.IS_FULL_COVERAGE) === 'true';

    if (!paymentKey || !amount || !orderId || !preReservationId) {
      alert(ALERT_MESSAGE_TYPE.NOT_ALLOWED_ACCESS);
      navigate(PAGE_NAME.index);
      return;
    } else {
      getPreReservation(preReservationId)
        .then((res) => {
          if (!hasRequestedPayment.current && !res?.reservation) {
            hasRequestedPayment.current = true;

            confirmPayment
              .mutateAsync({
                id: orderId,
                input: {
                  paymentKey,
                  amount,
                  isFullCoverage,
                  sureUserId: sureUserId ? Number(sureUserId) : undefined,
                  // 유입 채널을 ERP DB에 남겨 광고 성과를 실매출과 조인한다.
                  ...getReservationAttribution(),
                },
              })
              .then(() => {
                navigate(PAGE_NAME.confirm_payment, {
                  replace: true,
                });
              })
              .catch(() => {
                navigate(`${PAGE_NAME.payment_fail}`, {
                  replace: true,
                });
              })
              .finally(() => {
                sessionStorage.removeItem(SESSION_STORAGE_KEY.IS_FULL_COVERAGE);
                sessionStorage.removeItem(SESSION_STORAGE_KEY.REFERRAL_CODE);
                removeSureUserId();
              });
          }
        })
        .catch(() => {
          alert(ALERT_MESSAGE_TYPE.FAIL_GET_PRODUCT);
          navigate(PAGE_NAME.index);
        });
    }
  }, [paymentKey, amount, orderId]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <S.Wrapper isMobile={isMobile} screenHeight={screenHeight - 148}>
      <S.Text type='main' isMobile={isMobile}>
        결제가 진행중입니다
      </S.Text>
    </S.Wrapper>
  );
};

export default RequestPaymentPage;
